import React from 'react';
import { Menu } from 'antd';
import MenuFoldOutlined from '@ant-design/icons/MenuFoldOutlined';
import MenuUnfoldOutlined from '@ant-design/icons/MenuUnfoldOutlined';
import { authService } from 'leo-services';
import './style.scss';

const AppMenu = ({ state: { menuList, userName }, collapsed, onCollapsedChange }) => {
  const toggleCollapsed = () => {
    onCollapsedChange(!collapsed);
  };

  // 使用传统的 Menu.Item 和 Menu.SubMenu 组件（兼容 antd 4.7.0）
  const renderMenuItems = (list) => {
    return list.map((item) => {
      if (item.children && item.children.length > 0) {
        return (
          <Menu.SubMenu
            key={item.path}
            icon={<img className="menu-icon" src={item.svgIcon} alt="" />}
            title={item.name}
          >
            {renderMenuItems(item.children)}
          </Menu.SubMenu>
        );
      }
      return (
        <Menu.Item
          key={item.path}
          icon={<img className="menu-icon" src={item.svgIcon} alt="" />}
        >
          {item.name}
        </Menu.Item>
      );
    });
  };

  const handleLogout = async () => {
    await authService.logout();
    location.hash = 'login';
    location.reload();
  };

  return (
    <div className={`app-menu-container ${collapsed ? 'collapsed' : 'expanded'}`}>
      {/* Logo区域 */}
      <div
        className="system-logo"
        onClick={() => {
          location.hash = '/';
        }}
      >
        <img src={require('leo-assets/logo1.png')} alt="" />
        {!collapsed && (
          <div className="logo-name">
            <div className="name">国动网络</div>
          </div>
        )}
      </div>

      {/* 折叠按钮 */}
      <div className="collapse-trigger" onClick={toggleCollapsed}>
        {collapsed ? (
          <MenuUnfoldOutlined style={{ fontSize: '18px', color: '#6C6CEA' }} />
        ) : (
          <MenuFoldOutlined style={{ fontSize: '18px', color: '#6C6CEA' }} />
        )}
      </div>

      {/* 菜单列表 */}
      <Menu
        mode="inline"
        theme="light"
        inlineCollapsed={collapsed}
        className="menu-list"
        onClick={(itemData) => {
          location.hash = `/${itemData.keyPath.reverse().join('/')}`;
        }}
      >
        {renderMenuItems(menuList)}
      </Menu>

      {/* 底部工具栏 */}
      <div className="tools-button-container">
        <Menu
          mode="inline"
          theme="light"
          inlineCollapsed={collapsed}
          selectable={false}
          className="tools-menu"
          onClick={({ key }) => {
            if (key === 'logout') {
              handleLogout();
            }
          }}
        >
          <Menu.Item
            key="user"
            icon={<img className="menu-icon" src={require('leo-assets/account.svg')} alt="" />}
          >
            {userName || '加载中'}
          </Menu.Item>
          {userName && (
            <Menu.Item
              key="logout"
              icon={<img className="menu-icon" src={require('leo-assets/logout.svg')} alt="" />}
            >
              注销
            </Menu.Item>
          )}
        </Menu>
      </div>
    </div>
  );
};

export default AppMenu;
